import React from 'react';
import { Box, Container, Heading, Text, VStack, SimpleGrid, Icon, Badge, HStack, List, ListItem } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { FaCheck, FaQuestionCircle } from 'react-icons/fa';

const MotionBox = motion(Box);

const AIMasteryWhoFor = ({ data }) => {
  return (
    <Box py={{ base: 16, md: 20 }} bg="brand.50">
      <Container maxW="container.xl">
        <VStack spacing={12}>
          {/* Header */}
          <VStack spacing={4} textAlign="center">
            {data.badge && (
              <Badge
                px={4}
                py={2}
                bg="purple.500"
                color="white"
                fontSize="sm"
                fontWeight="700"
                borderRadius="full"
              >
                {data.badge}
              </Badge>
            )}
            <Heading size="2xl" fontWeight="900" color="brand.800">
              {data.title}
            </Heading>
            {data.subtitle && (
              <Text fontSize="lg" color="brand.600" maxW="3xl" fontWeight="600">
                {data.subtitle}
              </Text>
            )}
          </VStack>

          {/* Cards */}
          <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing={6} w="full">
            {data.personas?.map((persona, index) => (
              <MotionBox
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
              >
                <Box
                  p={6}
                  bg="white"
                  borderRadius="2xl"
                  boxShadow="0 4px 20px rgba(0,0,0,0.08)"
                  h="full"
                  _hover={{
                    transform: 'translateY(-8px)',
                    boxShadow: '0 12px 40px rgba(128,90,213,0.2)',
                  }}
                  transition="all 0.3s"
                >
                  <VStack spacing={4} align="center" textAlign="center">
                    <Box
                      p={4}
                      bg="purple.50"
                      borderRadius="xl"
                    >
                      <Icon
                        as={persona.icon}
                        boxSize={10}
                        color="purple.600"
                      />
                    </Box>
                    <Heading size="md" color="brand.700">
                      {persona.title}
                    </Heading>
                    <Text color="brand.500" fontSize="sm">
                      {persona.desc}
                    </Text>
                    {persona.check && (
                      <HStack spacing={2}>
                        <Icon as={FaCheck} color="accent.green" />
                        <Text fontSize="xs" color="accent.green" fontWeight="600">
                          You're Ready
                        </Text>
                      </HStack>
                    )}
                  </VStack>
                </Box>
              </MotionBox>
            ))}
          </SimpleGrid>

          {/* Reality Check Section */}
          {data.realityCheck && (
            <MotionBox
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.4 }}
              w="full"
            >
              <Box
                p={8}
                bg="purple.50"
                borderRadius="2xl"
                borderLeft="6px solid"
                borderColor="purple.500"
              >
                <VStack spacing={6} align="stretch">
                  <HStack spacing={3}>
                    <Icon as={FaQuestionCircle} boxSize={6} color="purple.600" />
                    <Heading size="lg" color="brand.800">
                      {data.realityCheck.title}
                    </Heading>
                  </HStack>
                  <List spacing={3}>
                    {data.realityCheck.questions?.map((question, index) => (
                      <ListItem key={index} color="brand.600" fontSize="md" fontStyle="italic">
                        <HStack align="flex-start" spacing={3}>
                          <Text color="purple.600" fontWeight="700" flexShrink={0}>Q{index + 1}:</Text>
                          <Text>{question}</Text>
                        </HStack>
                      </ListItem>
                    ))}
                  </List>
                </VStack>
              </Box>
            </MotionBox>
          )}
        </VStack>
      </Container>
    </Box>
  );
};

export default AIMasteryWhoFor;
